import { Component, OnInit, ViewChild, ɵɵqueryRefresh } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Personel, PersonelLogin } from 'src/app/models/Personel';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';
import { PersonelService } from 'src/app/services/personel.service';
import { MessagemodalComponent } from '../messagemodal/messagemodal.component';
import { ResetModalComponent } from '../reset-modal/reset-modal.component';
import { UpdateModalComponent } from '../update-modal/update-modal.component';

@Component({
  selector: 'app-kullanici-paneli',
  templateUrl: './kullanici-paneli.component.html',
  styleUrls: ['./kullanici-paneli.component.css']
})
export class KullaniciPaneliComponent implements OnInit {

  public userList: Array<Personel>;
  user: PersonelLogin;

  displayedColumns: string[] = ['TcNumber', 'SgkNumber', 'Name', 'Surname', 'Email', 'LockoutEnabled', 'Islemler'];
  dataSource: any;


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //arama kısmına tıklayınca aramayı siliyor
  clearSearch(event: Event) {
    (event.target as HTMLInputElement).value = "";
    this.dataSource.filter = "";
  }


  constructor(
    private personelService: PersonelService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) {
    this.user = JSON.parse(localStorage.getItem('personelInfo'));

    this.refreshTable();

  }

  ngOnInit(): void {

  }
  //tablo yenileme için mi kontrol et
  //this.table.renderRows();
  passwordReset(user: Personel) {
    this.dialog.open(ResetModalComponent, {
      data: {
        user: user,
        text: "Kullanıcının Şifresi SGK Numarası olacak Şekilde Güncellencek.",
        method: "reset",
      }
    });
  }

  userDelete(user: Personel) {
    /*
    this.dialog.open(ResetModalComponent,{ data: {
      user:user,
      text:"Kullanıcı Silinecek.",
      }});
*/
  }

  refreshTable() {
    this.userList = [];
    this.spinner.show();
    //bunu table a alcan
    this.personelService.getUserList(this.user.access_token).subscribe(res => {
      //console.log(res);

      for(let u of res){
        if(!u.LockoutEnabled){
          this.userList.push(u);
        }
      }
      //pasiflerde gösterilsin diye açılır
     //this.userList = res;

      this.dataSource = new MatTableDataSource(this.userList);
      this.spinner.hide();
    },
    error => {
      this.dialog.open(NotifymodalComponent, {
        data: {
          isSuccess: false,
          text: error.error.error,
          subject: "Tablo Yükleme"
        }
      });
    });
  }

  sendMessage(user: Personel) {
    this.dialog.open(MessagemodalComponent, {
      data: {
        user: user,
      }
    });
  }

  userAdd() {
    this.dialog.open(UpdateModalComponent, { 
      data: {} 
    }).afterClosed().subscribe(() => {
      this.refreshTable();
    });;
  }

  userUpdate(user: Personel) {
    this.dialog.open(UpdateModalComponent, {
      data: {
        user: user,
      }
    }).afterClosed().subscribe(() => {
      this.refreshTable();
    });
  }

  onChange(user: Personel, $event: MatSlideToggleChange) {
    //console.log($event.checked);
    let s = "";
    if ($event.checked) { s = "Aktif" } else { s = "Pasif" }

    this.dialog.open(ResetModalComponent, {
      data: {
        user: user,
        checked: $event.checked,
        text: "Kullanıcı " + s + " duruma alınacaktır.",
        method: "change",
      }
    }).afterClosed().subscribe(data => {
       if (data.changed == "false") {
         user.LockoutEnabled = !$event.checked;
         this.refreshTable();
        //console.log("if / "+!$event.checked);
      } else {
         user.LockoutEnabled = $event.checked;
         this.refreshTable();
        //console.log("else / "+$event.checked);
      }
      //console.log("modaldan gelen: "+JSON.stringify(data));
       
    });
  }

}

